(() => {
  if (window.spCardQuickAddReady) return;
  window.spCardQuickAddReady = true;
  const config = document.getElementById('sp-wishlist-config');
  const text = config ? JSON.parse(config.textContent).texts : {};
  let openPanel = null;
  let opener = null;
  let busy = false;
  const checks = new Map();
  function close(restore = true) {
    if (!openPanel) return;
    const panel = openPanel;
    panel.classList.remove('is-open');
    panel.hidden = true;
    opener?.setAttribute('aria-expanded', 'false');
    if (restore) opener?.focus({ preventScroll: true });
    openPanel = null;
  }
  async function verify(panel) {
    if (panel.dataset.custom === 'true') return false;
    const url = panel.dataset.productUrl;
    if (!checks.has(url)) checks.set(url, fetch(url, { credentials: 'same-origin' }).then(r => {
      if (!r.ok) throw new Error(text.cart_error);
      return r.text();
    }).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const data = doc.querySelector('[data-sp-wishlist-product]');
      if (!data) throw new Error(text.cart_error);
      return !JSON.parse(data.textContent).custom && !doc.querySelector('input[name^="properties["],select[name^="properties["],textarea[name^="properties["]');
    }).catch(error => { checks.delete(url); throw error; }));
    return checks.get(url);
  }
  async function open(button) {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    if (panel === openPanel) { close(); return; }
    close(false);
    opener = button;
    openPanel = panel;
    panel.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => { if (openPanel === panel) panel.classList.add('is-open'); });
    panel.querySelector('[data-sp-card-close]').focus({ preventScroll: true });
    const status = panel.querySelector('[data-sp-card-status]');
    const options = panel.querySelector('.sp-card-buy-options');
    panel.dataset.verified = 'false';
    options.querySelectorAll('button').forEach(b => { b.disabled = true; });
    status.textContent = '';
    try {
      const simple = await verify(panel);
      options.hidden = !simple;
      panel.dataset.verified = String(simple);
      status.textContent = simple ? '' : text.custom;
      if (simple) options.querySelectorAll('button').forEach(b => { b.disabled = b.dataset.available !== 'true'; });
    } catch (_) {
      status.textContent = text.cart_error;
    }
  }
  async function add(button) {
    const panel = button.closest('[data-sp-card-panel]');
    if (busy || panel.dataset.verified !== 'true') return;
    busy = true;
    const status = panel.querySelector('[data-sp-card-status]');
    panel.setAttribute('aria-busy', 'true');
    panel.querySelectorAll('[data-sp-card-variant]').forEach(b => { b.disabled = true; });
    status.textContent = text.adding;
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const root = window.Shopify?.routes?.root || '/';
    try {
      const body = { items: [{ id: Number(button.dataset.spCardVariant), quantity: 1 }], sections_url: location.pathname };
      if (cart) body.sections = cart.getSectionsToRender().map(s => s.id);
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body) });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || text.cart_error);
      status.textContent = text.ready;
      close(false);
      if (cart && data.sections) {
        cart.setActiveElement?.(opener);
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else location.assign(root + 'cart');
    } catch (error) {
      status.textContent = error.message || text.cart_error;
    } finally {
      busy = false;
      panel.removeAttribute('aria-busy');
      panel.querySelectorAll('[data-sp-card-variant]').forEach(b => { b.disabled = b.dataset.available !== 'true'; });
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sp-card-buy]');
    if (button) { event.preventDefault(); event.stopImmediatePropagation(); if (!busy) open(button); return; }
    if (event.target.closest('[data-sp-card-close]')) { event.preventDefault(); event.stopImmediatePropagation(); close(); return; }
    const variant = event.target.closest('[data-sp-card-variant]');
    if (variant) { event.preventDefault(); event.stopImmediatePropagation(); add(variant); return; }
    if (openPanel && !openPanel.contains(event.target)) close(false);
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && openPanel) { event.preventDefault(); close(); }
  });
})();
